import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';
import {
  convertUTCDateToLocalDate,
  formatDateddMMyyyy
} from 'helpers/dateHelper';
import moment from 'moment';
const ProspectCustTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleClickRow,
  onPageSizeChange
}) => {
  const columns = useMemo(
    () => [
      {
        accessor: 'id',
        Header: 'ID',
        isVisible: false
      },
      {
        accessor: 'customerName',
        Header: 'Customer Name'
      },
      {
        accessor: '#',
        Header: 'Visit Last Week',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;

          if (!lastVisitDate) return '';

          const localDate = moment.utc(lastVisitDate).local();
          const now = moment();
          const lastWeekStart = now
            .clone()
            .subtract(1, 'week')
            .startOf('isoWeek');
          const lastWeekEnd = now.clone().subtract(1, 'week').endOf('isoWeek');
          return localDate.isBetween(lastWeekStart, lastWeekEnd, null, '[]')
            ? 'Y'
            : '';
        }
      },
      {
        accessor: 'lastVisitDate',
        Header: 'Last Visit',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;
          const date = convertUTCDateToLocalDate(lastVisitDate);
          return formatDateddMMyyyy(date);
        }
      },
      {
        accessor: 'saleUserId',
        Header: 'Account Manager',
        Cell: rowData => {
          const { saleUserId } = rowData.row.original;
          return (
            <UsersInCellWidget usersText={saleUserId?.toString()} showName />
          );
        }
      },
      {
        accessor: 'visitType',
        Header: 'Visit Type',
        Cell: rowData => {
          const { visitType } = rowData.row.original;
          if(visitType == 0) return 'Prospect';
          if(visitType == 1) return 'New Customer'
          return 'Old Customer'
        }
      },
      {
        accessor: 'prospect',
        Header: 'Prospect',
        Cell: rowData => {
          const { isProspect } = rowData.row.original;
          return isProspect ? "✔" : "";
        }
      }
    ],
    []
  );

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

ProspectCustTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func
};

export default ProspectCustTable;
